import { makeStyles } from '@material-ui/core/styles'
import { colors } from '../utils/color'

export const useStyles = makeStyles({
  content: {
    display: 'grid',
    gap: '2rem',
  },
  grp: {
    display: 'grid',
    gap: '1rem',
  },
  link: {
    color: colors.themePrimary,
  },
  textField: {
    margin: 0,
    [`& fieldset`]: {
      borderRadius: 0,
    },
    '& .MuiInputBase-input': {
      background: '#fff',
    },
  },
  buttonMod: {
    width: '100%',
    '& .MuiButton-label': {
      justifyContent: 'center',
      padding: 4,
    },
  },
  noDecor: {
    textDecoration: 'none',
  },
})
